import { TorchApplication, TorchApplicationType } from '@/types/codegen-federation'
import { useTranslate } from '@/utils/translate/translate-client'
import { TorchApplicationStatus, TorchApplicationTypes } from '../../components/TorchApplicationContext'

const DRAFT_STATUSES = [TorchApplicationStatus.Incomplete, TorchApplicationStatus.Draft]

export const filterDraftTorchApplications = (applications: (TorchApplication | null)[] | null) =>
  applications?.filter((appl) =>
    DRAFT_STATUSES.includes(appl?.status as TorchApplicationStatus.Incomplete | TorchApplicationStatus.Draft),
  ) || []

export const filterApprovedTorchApplications = (applications: (TorchApplication | null)[] | null) =>
  applications?.filter((appl) => appl?.status === TorchApplicationStatus.Approved) || []

export const useTorchApplicationType = () => {
  const { t } = useTranslate('guild-create')

  return function getTorchApplicationType(type: TorchApplicationType | null | undefined) {
    switch (type) {
      case TorchApplicationTypes.Concept:
        return t('conceptVideo', 'Concept Video')
      case TorchApplicationTypes.CompletedEpisode:
        return t('completedEpisode', 'Completed Episode')
      case TorchApplicationTypes.CompletedMovie:
        return t('completedMovie', 'Completed Movie')
      default:
        return t('unknown', 'Unknown')
    }
  }
}
